import React, { ReactElement } from 'react'
import { translate } from 'helpers'
import {
  Eclipse,
  Loader,
  LoadingTitle,
  LoadingWrapper,
  Spinner,
  Wrapper
} from './subcomponents'
import { LoaderProps } from './typings'

const Loading = ({ isLoading, showLabel }: LoaderProps): ReactElement => {
  return (
    <Wrapper>
      {isLoading && (
        <LoadingWrapper>
          <LoadingTitle>
            {showLabel && translate({ string: 'loaderLabel' })}
          </LoadingTitle>
          <Loader data-testid="loader">
            <Spinner />
            <Eclipse />
          </Loader>
        </LoadingWrapper>
      )}
    </Wrapper>
  )
}

export default Loading
